import axios from 'axios'
import baseService from './baseService'
import userData from './data/user'
import User from '@/models/User'

const userService = {
  allUsers (params) {
    return new Promise((resolve, reject) => {
      if (baseService.isTestMode) {
        resolve(userData.all)
      } else {
        axios
          .get('/user/selectionlist?', baseService.defaultConfig)
          .then(response => {
            const apiResults = { ...response.data }
            if (!apiResults.errors) {
              apiResults.results = User.fromAPIList(response.data.results)
            }
            resolve(apiResults)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  },
  loadCurrentUser () {
    return new Promise((resolve, reject) => {
      axios.post(process.env.VUE_APP_ROOT_AUTH_API + 'users/me').then(response => {
        resolve(response.data)
      }).catch(error => {
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          console.log(error.response.data)
          console.log(error.response.status)
          console.log(error.response.headers)
          reject(error)
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          console.log(error.request)
          reject(new Error('Unable to reach authentication services. Please check network connection and try again.'))
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log('Error', error.message)
          reject(error)
        }
      })
    })
  },
  all (searchCriteria) {
    return new Promise((resolve, reject) => {
      if (baseService.isTestMode) {
        resolve(userData)
      } else {
        axios
          .post('/user/list', searchCriteria, baseService.defaultConfig)
          .then(response => {
            const apiResults = { ...response.data }
            if (!apiResults.errors) {
              apiResults.results = User.fromAPIList(response.data.results)
            }
            resolve(apiResults)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  },
  single (userId) {
    return new Promise((resolve, reject) => {
      if (baseService.isTestMode) {
        resolve(userData.all.find((x) => x.id === userId))
      } else {
        axios
          .post('/user/get?id=' + userId, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  },
  findAllByDealerId (dealerId) {
    return new Promise((resolve, reject) => {
      if (baseService.isTestMode) {
        resolve(userData)
      } else {
        axios
          .get('/user/findAllByDealerId?dealerId=' + dealerId, baseService.defaultConfig)
          .then(response => {
            const apiResults = { ...response.data }
            if (!apiResults.errors) {
              apiResults.results = User.fromAPIList(response.data.results)
            }
            resolve(apiResults)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  },
  findDealerUsersByRole (dealerId, roleId) {
    return new Promise((resolve, reject) => {
      if (baseService.isTestMode) {
        resolve(userData)
      } else {
        axios
          .get('/user/findDealerUsersByRole?dealerId=' + dealerId + '&roleId=' + roleId, baseService.defaultConfig)
          .then(response => {
            const apiResults = { ...response.data }
            if (!apiResults.errors) {
              apiResults.results = User.fromAPIList(response.data.results)
            }
            resolve(apiResults)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  }
}

export default userService
